import {Validator} from 'vee-validate';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import CONSTANT from './../../../../../../shared/constants/constant';
import CustomExpandableTable from '../../../../../../shared/components/customExpandableTable';
import Pagination from './../../../../../../shared/components/pagination';
import BookingService from './../../../../../services/cargobooking.service';
import ClientService from './../../../../../../clientmanagement/services/clientmanagement.service';

export default {
  name: 'basicinformation',
  components: {
    CustomExpandableTable,
    Pagination,
    VueElementLoading
  },
  props:['bookingData'],
  data() {
    return {
      accordianTab:{1:false, 2:false,3:false},
      expanded:false,
      isBasicInfoLoading:false,
      BookingMode:'',
      PickupPincode:'',
      RouteMode:'',
      TruckLoadType:'',
      DestinationHub:'',
      DestinationPincode:'',
      OriginHub:'',
      State:'',
      ConsigneeState:'',
      City:'',
      ConsigneeCity:'',
      pincode:'',
      breadth:'',
      height:'',
      length:'',
      box:'',
      Mobile:'',
      Telephone:'',
      Email:'',
      PickupGST:'',
      ShipmentDropByClient:false,
      PinCode:'',
      Address:'',
      SKU:'',
      LocationName:"",
      NumberOfMPS:'',
      boxes:'',
      TotalShipmentValue:'',
      TotalShipmentWeight:'',
      RequestedPickupDate:'',
      RequestedPickupTimeTo:'',
      NumberOfInvoice:'',
      RequestedPickupTimeFrom:'',
      shipmentData:[],
      userName:"",
      basicInformationData:[],
      boxTypeshow: true,
      ClientUOM:'',
      businesstype : '',
      airlinename : '',
      flighttype : '',
      producttype : '',
      airCargoOptions: ''
    }
  },
  computed: {},
 async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    if(this.bookingData){
      await this.getAirCargoData();
      this.setValues(this.bookingData);
    }
  },
  methods: {
    expandAll(){
      this.expanded = true;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = true;
      }
    },
    collapseAll(){
      this.expanded = false;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = false;
      }
    },
    toggleCheck(tabid){
      this.expanded = false;
      for (var key in this.accordianTab) {
        if(tabid != key){
          this.accordianTab[key] = false;
        }
      }
    },
    setValues(data){
      this.basicInformationData = data;
      let bookingmode = this.basicInformationData.bookingmode;
      if(this.basicInformationData.bookingmode.toLowerCase()=='topay'){
        bookingmode = 'To Pay';
      }
      this.bookingid = this.basicInformationData.id;
      this.TruckLoadType = this.basicInformationData.truckloadtype;
      this.RouteMode = this.basicInformationData.routemode;
      this.BookingMode = CONSTANT.BOOKING_MODE[bookingmode];
      this.PickupPincode = this.basicInformationData.pickuppincode;
      this.DestinationPincode = this.basicInformationData.destinationpincode;
      this.OriginHub = this.basicInformationData.originhub;
      this.DestinationHub = this.basicInformationData.destinationhubs;
      this.City = this.basicInformationData.pickupcity;
      this.State = this.basicInformationData.pickupstate;
      this.PinCode = this.basicInformationData.pickuppincode;
      this.PickupGST = this.basicInformationData.pickupgst;
      this.LocationName = this.basicInformationData.pickuplocationname;
      this.Mobile = this.basicInformationData.pickupmobile;
      this.Telephone = this.basicInformationData.pickuptelephone;
      this.Email = this.basicInformationData.pickupemail;
      this.Address = this.basicInformationData.pickupaddress;
      this.ShipmentDropByClient = (this.basicInformationData.dropbyclient==1)?'yes':'No';
      this.NumberOfMPS = this.basicInformationData.numberofmps;
      this.TotalShipmentValue = this.basicInformationData.totalshipmentvalues;
      this.TotalShipmentWeight = this.basicInformationData.totalphysicalweight;
      this.RequestedPickupDate = this.basicInformationData.requestedpickupdate;
      this.NumberOfInvoice = this.basicInformationData.numberofinvoices;
      this.RequestedPickupTimeFrom = this.basicInformationData.requestedpickuptimefrom;
      this.RequestedPickupTimeTo = this.basicInformationData.requestedpickuptimeto;
      this.shipmentData = this.basicInformationData.shipmentdetails;
      if (this.basicInformationData.bookingmode == 'PrePaid' &&
          this.basicInformationData.routemode == 'Air') {
        this.businesstype = this.airCargoOptions.resultbusinesstype.filter(item => {return item.id ==  this.bookingData.businesstype})[0].businesstype;
        this.airlinename = this.airCargoOptions.resultairlinename.filter(item => {return item.id ==  this.bookingData.airlinename})[0].airlinename;
        this.producttype = this.airCargoOptions.resultproducttype.filter(item => {return item.id ==  this.bookingData.producttype})[0].producttype;
        this.flighttype = this.airCargoOptions.resultflighttype.filter(item => {return item.id ==  this.bookingData.flighttype})[0].flighttype;
      }
      this.checkBoxtypeConfig();
    },
    async checkBoxtypeConfig() {
      try {
        if (this.basicInformationData.clientid && this.basicInformationData.clientbusinessaccountid) {
          let InputPayload = {
            clientid: this.basicInformationData.clientid,
            clientbusinessaccountid: this.basicInformationData.clientbusinessaccountid
          }
          let result = await ClientService.getAllClientBoxType(InputPayload);
          if (result.data.data.boxtype.length == 0) {
            this.boxTypeshow = false;
          } else {
            this.boxTypeshow = true;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getAirCargoData() {
      try {
        let InputPayload = {};
        let result = await BookingService.getAirCargoData(InputPayload);
        if (result.data.code == 200) {
          this.airCargoOptions = result.data.data;
        }else{
          this.$alertify.error(result.data.message);
        }

      } catch (err) {
        console.log(err);
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/bookingListing/bookingview/basicinformation/basicinformation.component.js